export let nullSafeValueFormatter = (v: number | null) =>
  v == null ? '' : String(v)
